import styled from "styled-components";

import { IconSize } from "./types";

export const sizes = {
  extraSmall: 8,
  small: 16,
  regular: 24,
  medium: 32,
  large: 40,
  extraLarge: 48,
};

type SizedIconProps = {
  $iconSize: IconSize;
};

export const getIconSizeValue = (size: IconSize) => sizes[size];

export const SizedIcon = styled.span<SizedIconProps>`
  display: inline-block;
  width: ${({ $iconSize }): number => getIconSizeValue($iconSize)}px;
  height: ${({ $iconSize }): number => getIconSizeValue($iconSize)}px;

  svg {
    width: ${({ $iconSize }): number => getIconSizeValue($iconSize)}px;
    height: ${({ $iconSize }): number => getIconSizeValue($iconSize)}px;
  }
`;
